<template>
  <span v-if="permitido" class="d-inline-block d-print-none">
    <b-button type="button" variant="warning" :size="size" title="Remanejar" @click="$bvModal.show(modalId)">
      <i class="fas fa-exchange-alt" aria-hidden="true" /> Remanejar
    </b-button>
    <ModalRemanejamento :modal-id="modalId" :servico="servico" :registro-id="registro.id" @remanejado="$emit('remanejado')" />
  </span>
</template>
<script>
import ModalRemanejamento from './ModalRemanejamento';
const controllers = {
  atendimento: 'AtendimentoController', acompanhamento: 'PafController', atividades: 'AtividadeController',
  beneficio: 'BeneficioFamiliaController', encaminhamentos: 'EncaminhamentoController', medidas: 'MedidasController',
  violacaodedireitos: 'ViolenciaViolacaoDireitoController', programassociais: 'ProgramaSocialFamiliaController',
  referenciamentos: 'ReferenciaController', oficios: 'OficioController', denuncias: 'DenunciaController',
  acolhimentos: 'AcolhimentoController', 'acolhimento-crianca': 'AcolhimentoCriancaController',
  'acolhimento-idoso': 'AcolhimentoGeralController',
};
export default {
  components: { ModalRemanejamento },
  props: { servico: { type: String, required: true }, registro: { type: Object, default: () => ({}) }, size: { type: String, default: 'sm' } },
  computed: {
    modalId() { return `remanejar-${this.servico}-${this.registro.id}-${this._uid}`; },
    permitido() {
      const user = this.$store.state.user;
      if (!user || !this.registro || !this.registro.id) return false;
      const role = user.role_details && user.role_details.name;
      if (role !== 'Admin' && !(user.permissions && user.permissions[controllers[this.servico]])) return false;
      const responsavel = this.registro.user_id || (this.registro.user && this.registro.user.id);
      return ['Admin', 'Gestor(a)'].includes(role) || (responsavel && Number(user.id) === Number(responsavel));
    },
  },
};
</script>
